import Report from "report";
import TableReportHelper from "report/helper";
import ReunioesParticipanteReport from "./ReunioesParticipanteReport";
import Inscricao from "..";
import QRCode from "qrcode";
export default class AgendasParticipantes extends Report {
    constructor(obj) {
        super();

        this.obj = obj;
        // this.lista = obj.lista;
        this.inscricoes = obj.inscricoes;
        this.reunioes = obj.reunioes;
    }

    get title() {
        return "Agenda de Reuniões";
    }

    get fileName() {
        return this.title;
    }

    async render() {
        this.helper = new TableReportHelper(this.inscricoes);
        let content = [];
        let breakPage = false;
        for (let index = 0; index < this.inscricoes.length; index++) {
            const et = this.inscricoes[index];
            if (breakPage) {
                content.push(this.helper.pageBreak());
            }
            breakPage = false;
            let reunioesP = this.reunioes
                .filter((r) => r.inscricao1.uid === et.uid)
                .concat(this.reunioes.filter((r) => r.inscricao2.uid === et.uid));

            reunioesP = reunioesP.sort((a, b) => {
                //2024-09-12T17:30
                let ha = a.horario.horario;
                let hb = b.horario.horario;
                return ha.localeCompare(hb);
            });
            if (reunioesP.length) {
                const imgQrCode = await QRCode.toDataURL(Inscricao.getUrlPainelInscrito(et.uid), {
                    width: 128,
                    margin: 1,
                    color: {
                        dark: "#000000",
                        light: "#ffffff",
                    },
                });

                content.push(ReunioesParticipanteReport.renderAgendaParticipante(et, reunioesP, imgQrCode));
                breakPage = true;
            }
        }

        return content;
    }
}
